export function isDevOrTestEnv() {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.localhost')) {
      return true;
    }
  }
  return env === 'development' || env === 'test' || env === 'dev';
}

/**
 * Returns true if the backend should ignore video size/length limits.
 * Controlled by env var: IGNORE_VIDEO_LIMITS ("true" to ignore limits)
 */
export function shouldIgnoreVideoLimits() {
  return true;
  return process.env.IGNORE_VIDEO_LIMITS === 'true';
}
